module.exports = "/* You can add global styles to this file, and also import other style files */\nhtml, body {\n  width: 100%;\n  height: 100%;\n  font-family: \"Helvetica Neue\", Helvetica, sans-serif;\n  color: #444;\n  -webkit-font-smoothing: antialiased;\n  background: #f0f0f0;\n  margin: 0px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles